import React from 'react'

type Props = {
  show: boolean
  title?: string
  description?: string
}

const LoadingOverlay: React.FC<Props> = ({
  show,
  title = 'Yükleniyor...',
  description,
}) => {
  if (!show) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'wait',
      }}
      aria-live='polite'
      aria-busy='true'
    >
      <div
        className='d-flex flex-column align-items-center bg-white rounded shadow p-6'
        style={{minWidth: 220}}
      >
        <div
          className='spinner-border text-primary mb-3'
          role='status'
          style={{width: '3rem', height: '3rem'}}
        >
          <span className='visually-hidden'>{title}</span>
        </div>
        <div className='fs-5 fw-semibold text-gray-800'>{title}</div>
        {description && <div className='fs-7 text-muted mt-1'>{description}</div>}
      </div>
    </div>
  )
}

export default LoadingOverlay
